import { JWTPayload } from 'jose'
import storageService from './storage.service'
import tokenService from './token.service'

interface TokenData extends JWTPayload {
  id: number
}

export default {
  tokenData (): TokenData | null {
    const token = storageService.get('authToken')
    const data = tokenService.decode(token) as TokenData | null
    if (!data || (typeof (data) === 'string')) return null
    return data
  }
}
